import React, {FC} from "react";
import {Box} from "@chakra-ui/react";
import {ShowFilter} from "../../components/Filter/ShowFilter";
import {FieldType} from "../../common/constants";

type StatusFilterOption = { id: number; name: string };

type OrderHistoryLegacyFiltersProps = {
    isMobile: boolean;
    showDealershipColumn: boolean;
    showStatusColumn: boolean;
    showAmountColumn: boolean;
    statusFilterOptions: StatusFilterOption[];
    getFilterValue: (key: string) => string;
    legacyDateRangeValue: string;
    applyLegacyFilterValue: (val: Record<string, string>) => void;
};

export const OrderHistoryLegacyFilters: FC<OrderHistoryLegacyFiltersProps> = ({
    isMobile,
    showDealershipColumn,
    showStatusColumn,
    showAmountColumn,
    statusFilterOptions,
    getFilterValue,
    legacyDateRangeValue,
    applyLegacyFilterValue,
}) => {
    return (
        <Box>
            {getFilterValue("order") && (
                <ShowFilter
                    specialLabel="Order"
                    uniqueName="order"
                    type={FieldType.Input}
                    updateFunc={applyLegacyFilterValue}
                    value={getFilterValue("order")}
                />
            )}
            {(getFilterValue("dateFrom") || getFilterValue("dateTo")) && (
                <ShowFilter
                    specialLabel="Date"
                    uniqueName="date"
                    type={FieldType.DateRange}
                    updateFunc={applyLegacyFilterValue}
                    value={legacyDateRangeValue}
                />
            )}
            {showDealershipColumn && getFilterValue("dealership") && (
                <ShowFilter
                    specialLabel="Dealership"
                    uniqueName="dealership"
                    type={FieldType.Input}
                    updateFunc={applyLegacyFilterValue}
                    value={getFilterValue("dealership")}
                />
            )}
            {getFilterValue("user") && (
                <ShowFilter
                    specialLabel="User"
                    uniqueName="user"
                    type={FieldType.Input}
                    updateFunc={applyLegacyFilterValue}
                    value={getFilterValue("user")}
                />
            )}
            {showStatusColumn && getFilterValue("status") && (
                <ShowFilter
                    specialLabel="Status"
                    uniqueName="status"
                    type={FieldType.Select}
                    options={statusFilterOptions.map((option) => ({
                        id: option.id < 0 ? "" : String(option.id),
                        name: option.name || "",
                    }))}
                    updateFunc={applyLegacyFilterValue}
                    value={getFilterValue("status")}
                />
            )}
            {showAmountColumn && getFilterValue("amount") && (
                <ShowFilter
                    specialLabel="Amount"
                    uniqueName="amount"
                    type={FieldType.Input}
                    updateFunc={applyLegacyFilterValue}
                    value={getFilterValue("amount")}
                />
            )}
        </Box>
    );
};

export default OrderHistoryLegacyFilters;
